import { render, staticRenderFns } from "./vupoint.vue?vue&type=template&id=253019a1&scoped=true"
import script from "./vupoint.vue?vue&type=script&lang=js"
export * from "./vupoint.vue?vue&type=script&lang=js"
import style0 from "./vupoint.vue?vue&type=style&index=0&id=253019a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253019a1",
  null
  
)

export default component.exports